import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ColorPickerModule } from 'ngx-color-picker';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatBadgeModule } from '@angular/material/badge';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { NgxEditorModule } from 'ngx-editor';
import { AngularEditorModule } from '@kolkov/angular-editor';

import { MaterialModule } from '../app-material.module';
import { PipesModule } from '../pipes/pipes.module';

// Shared components
import { ConfirmacionComponent } from '../home/confirmacion/confirmacion.component';
import { ConfirmarllamadaComponent } from '../home/confirmarllamada/confirmarllamada.component';
import { MoretextComponent } from '../home/moretext/moretext.component';
import { MapaDialogComponent } from '../components/mapa-dialog/mapa-dialog.component';
import { MapaValidacionDialogComponent } from '../components/mapa-dialog/mapa-validacion-dialog/mapa-validacion-dialog.component';
import { BitacoraDialogComponent } from '../components/bitacora-dialog/bitacora-dialog.component';
import { ComentarioDialogComponent } from '../components/comentario-dialog/comentario-dialog.component';
import { DescargarLotesComponent } from '../home/descargar-lotes/descargar-lotes.component';
import { FiltrosRepcampanaComponent } from '../home/filtros-repcampana/filtros-repcampana.component';
import { AlertaFlotanteComponent } from '../components/alerta-flotante/alerta-flotante.component';
import { AlarmaDetalleDialogComponent } from '../components/alerta-flotante/alarma-detalle-dialog/alarma-detalle-dialog.component';
import { CertificateBadgeComponent } from '../components/certificate-badge/certificate-badge.component';
import { InfoCardComponent } from '../components/info-card/info-card.component';
import { CertificateQueryComponent } from '../components/certificate-query/certificate-query.component';
import { WexllamadasComponent } from '../components/wexllamadas/wexllamadas.component';
import { PasswordnewComponent } from '../login/passwordnew/passwordnew.component';
import { ConsultaCertificadoNacimietoComponent } from '../home/consulta-certificado-nacimieto/consulta-certificado-nacimieto.component';
import { MonitorRealtimeFtthDialogComponent } from '../home/consulta-certificado-nacimieto/monitor-realtime-ftth-dialog/monitor-realtime-ftth-dialog.component';
import { HistorialcertificadoComponent } from '../home/historialcertificado/historialcertificado.component';
import { VerCertificadoDialogComponent } from '../home/historialcertificado/ver-certificado-dialog/ver-certificado-dialog.component';
import { PxaComponent } from '../home/pxa/pxa.component';
import { PxaDialogComponent } from '../home/pxa/pxa-dialog/pxa-dialog.component';
import { PxaSimuladorComponent } from '../home/pxa/pxa-simulador/pxa-simulador.component';
import { PxaAuditoriaComponent } from '../home/pxa/pxa-auditoria/pxa-auditoria.component';
import { CitasProgramadasComponent } from '../home/citas-programadas/citas-programadas.component';
import { DlgCitaprogramComponent } from '../home/citas-programadas/dlg-citaprogram/dlg-citaprogram.component';
import { DlgEditarCuentaComponent } from '../home/citas-programadas/dlg-editar-cuenta/dlg-editar-cuenta.component';
// Modulos compartidos para vista del agente con permisos
import { MapaCitaComponent } from '../home/mapa-cita/mapa-cita.component';
import { MapaCitaFiltersComponent } from '../home/mapa-cita/mapa-cita-filters/mapa-cita-filters.component';
import { MapaCitaAlarmasTableComponent } from '../home/mapa-cita/mapa-cita-alarmas-table/mapa-cita-alarmas-table.component';
import { MapaTecnicoComponent } from '../home/mapa-tecnico/mapa-tecnico.component';
import { ScheduleCitasComponent } from '../home/schedule-citas/schedule-citas.component';
import { MonitoreoComponent } from '../home/monitoreo/monitoreo.component';
import { MonitoreoHeatmapComponent } from '../home/monitoreo/monitoreo-heatmap/monitoreo-heatmap.component';
import { MonitoreoSubtipoHeatmapComponent } from '../home/monitoreo/monitoreo-subtipo-heatmap/monitoreo-subtipo-heatmap.component';
import { MonitoreoAlarmasComponent } from '../home/monitoreo/monitoreo-alarmas/monitoreo-alarmas.component';
import { RepoAlarmaInfructuosaComponent } from '../home/repo-alarma-infructuosa/repo-alarma-infructuosa.component';
import { HistorialWhatsappDialogComponent } from '../home/historial-whatsapp-dialog/historial-whatsapp-dialog.component';
import { DateRangeFilterComponent } from './date-range-filter/date-range-filter.component';

// Modulos operacionales compartidos (rutas /home y potencialmente /homeagente)
import { DashboardComponent } from '../home/dashboard/dashboard.component';
import { ReporteCitaComponent } from '../home/reporte-cita/reporte-cita.component';
import { ReporteFallapersisteComponent } from '../home/reporte-fallapersiste/reporte-fallapersiste.component';
import { FallasPendientesComponent } from '../home/fallas-pendientes/fallas-pendientes.component';
import { MapaMovimientoTecComponent } from '../home/mapa-movimiento-tec/mapa-movimiento-tec.component';
import { BitacoraGeneralComponent } from '../home/bitacora-general/bitacora-general.component';
import { CruceSgoComponent } from '../home/cruce-sgo/cruce-sgo.component';
import { FibProactivosComponent } from '../home/fib-proactivos/fib-proactivos.component';
import { BitacoraProactivosComponent } from '../home/bitacora-proactivos/bitacora-proactivos.component';
import { NuevasOrdenesSinCitaComponent } from '../supervisor/nuevas-ordenes-sin-cita/nuevas-ordenes-sin-cita.component';
import { AutoasignacionLejanasComponent } from '../home/autoasignacion-lejanas/autoasignacion-lejanas.component';
import { AsignarCitaLejanaDialogComponent } from '../home/autoasignacion-lejanas/asignar-cita-lejana-dialog/asignar-cita-lejana-dialog.component';
import { GarantiaD2dComponent } from '../home/garantia-d2d/garantia-d2d.component';
import { CrearGarantiaDialogComponent } from '../home/garantia-d2d/crear-garantia-dialog/crear-garantia-dialog.component';
import { AtenderGarantiaDialogComponent } from '../home/garantia-d2d/atender-garantia-dialog/atender-garantia-dialog.component';
import { VerGarantiaDialogComponent } from '../home/garantia-d2d/ver-garantia-dialog/ver-garantia-dialog.component';
import { BitacoraTecnicoComponent } from '../home/bitacora-tecnico/bitacora-tecnico.component';

@NgModule({
  declarations: [
    ConfirmacionComponent,
    ConfirmarllamadaComponent,
    MoretextComponent,
    MapaDialogComponent,
    MapaValidacionDialogComponent,
    BitacoraDialogComponent,
    ComentarioDialogComponent,
    DescargarLotesComponent,
    FiltrosRepcampanaComponent,
    AlertaFlotanteComponent,
    AlarmaDetalleDialogComponent,
    CertificateBadgeComponent,
    InfoCardComponent,
    CertificateQueryComponent,
    WexllamadasComponent,
    PasswordnewComponent,
    ConsultaCertificadoNacimietoComponent,
    MonitorRealtimeFtthDialogComponent,
    HistorialcertificadoComponent,
    VerCertificadoDialogComponent,
    PxaComponent,
    PxaDialogComponent,
    PxaSimuladorComponent,
    PxaAuditoriaComponent,
    CitasProgramadasComponent,
    DlgCitaprogramComponent,
    DlgEditarCuentaComponent,
    MapaCitaComponent,
    MapaCitaFiltersComponent,
    MapaCitaAlarmasTableComponent,
    MapaTecnicoComponent,
    ScheduleCitasComponent,
    MonitoreoComponent,
    MonitoreoHeatmapComponent,
    MonitoreoSubtipoHeatmapComponent,
    MonitoreoAlarmasComponent,
    RepoAlarmaInfructuosaComponent,
    HistorialWhatsappDialogComponent,
    DateRangeFilterComponent,
    // Operacionales movidos desde AppModule
    DashboardComponent,
    ReporteCitaComponent,
    ReporteFallapersisteComponent,
    FallasPendientesComponent,
    MapaMovimientoTecComponent,
    BitacoraGeneralComponent,
    CruceSgoComponent,
    FibProactivosComponent,
    BitacoraProactivosComponent,
    NuevasOrdenesSinCitaComponent,
    AutoasignacionLejanasComponent,
    AsignarCitaLejanaDialogComponent,
    GarantiaD2dComponent,
    CrearGarantiaDialogComponent,
    AtenderGarantiaDialogComponent,
    VerGarantiaDialogComponent,
    BitacoraTecnicoComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    NgxSpinnerModule,
    PipesModule,
    ColorPickerModule,
    NgScrollbarModule,
    PickerModule,
    MatButtonToggleModule,
    MatBadgeModule,
    NgxMatSelectSearchModule,
    TooltipModule,
    AngularFontAwesomeModule,
    NgxEditorModule,
    AngularEditorModule,
  ],
  exports: [
    // Re-export common modules so feature modules don't need to import them individually
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    NgxSpinnerModule,
    PipesModule,
    ColorPickerModule,
    NgScrollbarModule,
    PickerModule,
    MatButtonToggleModule,
    MatBadgeModule,
    NgxMatSelectSearchModule,
    TooltipModule,
    AngularFontAwesomeModule,
    NgxEditorModule,
    AngularEditorModule,
    // Export shared components
    ConfirmacionComponent,
    ConfirmarllamadaComponent,
    MoretextComponent,
    MapaDialogComponent,
    MapaValidacionDialogComponent,
    BitacoraDialogComponent,
    ComentarioDialogComponent,
    DescargarLotesComponent,
    FiltrosRepcampanaComponent,
    AlertaFlotanteComponent,
    AlarmaDetalleDialogComponent,
    CertificateBadgeComponent,
    InfoCardComponent,
    CertificateQueryComponent,
    WexllamadasComponent,
    PasswordnewComponent,
    ConsultaCertificadoNacimietoComponent,
    MonitorRealtimeFtthDialogComponent,
    HistorialcertificadoComponent,
    VerCertificadoDialogComponent,
    PxaComponent,
    PxaDialogComponent,
    PxaSimuladorComponent,
    PxaAuditoriaComponent,
    CitasProgramadasComponent,
    DlgCitaprogramComponent,
    DlgEditarCuentaComponent,
    MapaCitaComponent,
    MapaCitaFiltersComponent,
    MapaCitaAlarmasTableComponent,
    MapaTecnicoComponent,
    ScheduleCitasComponent,
    MonitoreoComponent,
    MonitoreoHeatmapComponent,
    MonitoreoSubtipoHeatmapComponent,
    MonitoreoAlarmasComponent,
    RepoAlarmaInfructuosaComponent,
    HistorialWhatsappDialogComponent,
    DateRangeFilterComponent,
    // Operacionales movidos desde AppModule
    DashboardComponent,
    ReporteCitaComponent,
    ReporteFallapersisteComponent,
    FallasPendientesComponent,
    MapaMovimientoTecComponent,
    BitacoraGeneralComponent,
    CruceSgoComponent,
    FibProactivosComponent,
    BitacoraProactivosComponent,
    NuevasOrdenesSinCitaComponent,
    AutoasignacionLejanasComponent,
    AsignarCitaLejanaDialogComponent,
    GarantiaD2dComponent,
    CrearGarantiaDialogComponent,
    AtenderGarantiaDialogComponent,
    VerGarantiaDialogComponent,
    BitacoraTecnicoComponent,
  ],
  entryComponents: [
    ConfirmacionComponent,
    ConfirmarllamadaComponent,
    MoretextComponent,
    MapaDialogComponent,
    MapaValidacionDialogComponent,
    BitacoraDialogComponent,
    ComentarioDialogComponent,
    DescargarLotesComponent,
    FiltrosRepcampanaComponent,
    AlarmaDetalleDialogComponent,
    PasswordnewComponent,
    VerCertificadoDialogComponent,
    MonitorRealtimeFtthDialogComponent,
    PxaDialogComponent,
    PxaSimuladorComponent,
    PxaAuditoriaComponent,
    DlgCitaprogramComponent,
    DlgEditarCuentaComponent,
    AsignarCitaLejanaDialogComponent,
    HistorialWhatsappDialogComponent,
    CrearGarantiaDialogComponent,
    AtenderGarantiaDialogComponent,
    VerGarantiaDialogComponent,
  ]
})
export class SharedModule { }
